import { TransactionType } from "./enums";

export interface TransactionInOut {
  address: string;
  amount: number;
  index: number;
  type: string;
  outTxID: string | null;
  nextTx: string | null;
}

export interface Transaction {
  blockHeight: number;
  chainID: string;
  blockTime: string | null;
  chainTime: string;
  endTime: string | null;
  startTime: string | null;
  feePercentage: number;
  inputs: TransactionInOut[];
  nodeID: string;
  outputs: TransactionInOut[];
  txID: string;
  type: TransactionType;
  weight: number;

  [key: string]: any;
}

export enum ExportImportType {
  EXPORT = "export",
  IMPORT = "import"
}

export interface CChainInputOutput {
  value: number;
  address: {
    address: string | null;
    p_address: string | null;
  } | null;
  addresses: string[] | null;
  tx_id: string | null;
}

export interface ExportImportTransaction {
  id: number;
  tx_id: string;
  tx_block: number;
  timestamp: number;
  total_gas: number;
  exportedinput_set: CChainInputOutput[] | null;
  exportedoutput_set: CChainInputOutput[] | null;
  importedinput_set: CChainInputOutput[] | null;
  importedoutput_set: CChainInputOutput[] | null;
  type: ExportImportType;
}
